import { connect } from 'react-redux';
import {
  changeParticipateStep, toggleParticipateForm, getParticipateForm
} from 'project/ducks/form';
import { getProject } from 'project/ducks/project';
import { createProjectEntry, fetchProjectEntries } from 'project/ducks/entries';
import { createEntryRevision } from 'project/ducks/revisions';
import { canWatch } from 'project/utils';
import { getSubCategory } from 'common/ducks/categories';
import ParticipateForm from 'project/components/participate_form';

function mapStateToProps(state) {
  const project = getProject(state);
  return {
    project,
    subCategory: getSubCategory(state.categories, project.sub_category),
    user: state.user.profile_data,
    currentStep: getParticipateForm(state).currentStep,
    formOpen: getParticipateForm(state).formOpen,
    canWatch: canWatch(state)
  };
}

export default connect(mapStateToProps, {
  changeStep: changeParticipateStep,
  toggleForm: toggleParticipateForm,
  createProjectEntry,
  createEntryRevision,
  fetchProjectEntries,
})(ParticipateForm);



// WEBPACK FOOTER //
// ./project/containers/participate_form.jsx